import { Link } from 'react-router-dom';
import './css/bootstrap.min.css';
import './css/estilo.css';
import { useGoToStep } from '../hooks/useGoToStep';
import { InputChangedProvider } from '../context/InputChangedContext';

import { useEffect, useState } from 'react';

const Menu = () => {
    // Lee el flag de cambios no guardados desde sessionStorage
    //const [hasUnsaved, setHasUnsaved] = useState(false);

    const handleClick = (item) => {
        console.log(`Has hecho clic en el ${item} `);
    };

    const { goToStep, ConfirmModal, IncompleteModal } = useGoToStep(useGoToStep);
    //const goToStep = useGoToStep(InputChangedProvider);
    const handlePaso1 = (e) => goToStep(e, "paso1");
    const handlePaso2 = (e) => goToStep(e, "paso2");
    const handlePaso3 = (e) => goToStep(e, "paso3");
    const handlePaso4 = (e) => goToStep(e, "paso4");

    return (
        <>
            <div className="wpr-autoservicio">
                <a className="btn btn-autoservicio" href="https://alumnos.unapec.edu.do/StudentSelfService">Regresar al autoservicio</a>
                <span className="separador"></span>
            </div>

            <p className="titulo"><strong>Pasos del formulario:</strong></p>
               <ul className="cntulist lista-pasos">
                 <li className='clkm-item'><Link onClick={handlePaso1} className='clk-link'><span><span className="num">1</span> Datos residencia habitual</span></Link></li>
                 <li className='clkm-item'><Link onClick={handlePaso2} /*to="/paso2"*/ className='clk-link'><span><span className="num">2</span> Datos de su nacimiento</span></Link></li>
                 <li className='clkm-item'><Link onClick={handlePaso3}/*to="/paso3"*/ className='clk-link'><span><span className="num">3</span> Información Laboral</span></Link></li>
                 <li className='clkm-item'><Link onClick={handlePaso4}/*to="/paso4"*/ className='clk-link'><span><span className="num">4</span> Información de Salud</span></Link></li>
              </ul>  
            {/* Modal */}
                <ConfirmModal />
                <IncompleteModal />
            {/* Fin Modal */}                      
        </>
    );
}


export default Menu;